import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .trim()
      .required("This field is required")
      .max(100, "Name must be less than 100 characters"),
    image: Yup.string()
      .trim()
      .nullable()
      .required("This field is required"),
    service: Yup.string().required("This field is required")
  }),
  mapPropsToValues: props => ({
    id: props.editedData
      ? props && props.editedData && props.editedData.id
      : "",
    name: props.editedData
      ? props && props.editedData && props.editedData.name
      : "",
    image: props.editedData
      ? props && props.editedData && props.editedData.file_name
      : "",
    service: props.editedData
      ? typeof props.editedData.service == "object"
        ? props.editedData.service.id
        : props.editedData.service
      : ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
